import { render } from "./IdealTextQuestion.vue?vue&type=template&id=c3157f96"
import script from "./IdealTextQuestion.vue?vue&type=script&lang=js"
export * from "./IdealTextQuestion.vue?vue&type=script&lang=js"

import "./IdealTextQuestion.vue?vue&type=style&index=0&id=c3157f96&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__